<template>
  <div>
    <div class="bg-body"/>
    <div>
      <div class="file-head-bg"/>
      <div class="col-md-12 file-head-content">
        <div class="file-header">
          <div class="col-10">
            <div class="file-header-title">Messages</div>
          </div>
          <div class="col-2 file-header-logo"><img src="@/assets/img/logo.png"></div>
        </div>
      </div>
    </div>

    <div class="messages-group">
      <div class="messages-group-menu">
        <div class="messages-group-menu-icon-left--inactive "><img src="@/assets/img/messages/boite.png"></div>
        <div class="messages-group-menu-label messages-group-menu-label--inactive">Ma boite de réception (prochainement)</div>
        <div class="messages-group-menu-icon-right "><img src="@/assets/img/messages/next.png"></div>
      </div>
    </div>

    <div class="messages-group">
      <div v-if="ifCampus != null" class="messages-group-menu messages-group-menu-link" @click="urlContact">
        <div class="messages-group-menu-icon-left "><img src="@/assets/img/messages/phone.png"></div>
        <div class="messages-group-menu-label">Contacter mon centre Apform</div>
        <div class="messages-group-menu-icon-right "><img src="@/assets/img/messages/next.png"></div>
      </div>
      <div v-else class="messages-group-menu">
        <div class="messages-group-menu-icon-left--inactive "><img src="@/assets/img/messages/phone.png"></div>
        <div class="messages-group-menu-label messages-group-menu-label--inactive">Contacter mon centre Apform</div>
        <div class="messages-group-menu-icon-right "><img src="@/assets/img/messages/next.png"></div>
      </div>

      <div class="messages-group-dash"/>

      <div v-if="ifHandicap" class="messages-group-menu messages-group-menu-link" @click="urlHandicap">
        <div class="messages-group-menu-icon-left "><img src="@/assets/img/messages/handicap.png"></div>
        <div class="messages-group-menu-label">Référent handicap</div>
        <div class="messages-group-menu-icon-right "><img src="@/assets/img/messages/next.png"></div>
      </div>
      <div v-else class="messages-group-menu">
        <div class="messages-group-menu-icon-left--inactive"><img src="@/assets/img/messages/handicap.png"></div>
        <div class="messages-group-menu-label messages-group-menu-label--inactive">Référent handicap</div>
        <div class="messages-group-menu-icon-right "><img src="@/assets/img/messages/next.png"></div>
      </div>

      <div class="messages-group-dash"/>

      <div class="messages-group-menu">
        <div class="messages-group-menu-icon-left--inactive "><img src="@/assets/img/messages/files.png"></div>
        <div class="messages-group-menu-label messages-group-menu-label--inactive">Documentation (prochainement)</div>
        <div class="messages-group-menu-icon-right "><img src="@/assets/img/messages/next.png"></div>
      </div>

      <div class="messages-group-dash"/>

      <div class="messages-group-menu messages-group-menu-link" @click="help">
        <div class="messages-group-menu-icon-left "><img src="@/assets/img/messages/alert.png"></div>
        <div class="messages-group-menu-label">Signaler un problème technique</div>
        <div class="messages-group-menu-icon-right "><img src="@/assets/img/messages/next.png"></div>
      </div>
    </div>

    <div class="messages-follow">
      <div class="messages-follow-label">Suivre APFORM</div>
      <div class="messages-follow-icons">
        <img class="messages-follow-icons-img" src="@/assets/img/messages/reseaux/facebook.png" @click="urlFacebook">
        <img class="messages-follow-icons-img" src="@/assets/img/messages/reseaux/linkedin.png" @click="urlLinkedin">
        <img class="messages-follow-icons-img" src="@/assets/img/messages/reseaux/instagram.png" @click="urlInstagram">
      </div>
    </div>
  </div>
</template>

<script>

import UserService from "@/services/user.service";

export default {
  name: "Messages",
  data() {
    return {
      referentHandicap: null,
      ifHandicap: null,
      ifCampus: null
    }
  },
  mounted() {
    UserService.getDashboardContent("Messages").then(
        (response) => {
          this.ifCandidature = response.data.ifCandidature
          this.ifEligible = response.data.ifEligible
          this.statut = response.data.statut
          this.ifTestOpened = response.data.ifTestOpened
          this.ifTestFinished = response.data.ifTestFinished
          this.ifTestEnCours = response.data.ifTestEnCours
          this.dayRemaining = response.data.dayRemaining
          this.statutEntretien = response.data.statutEntretien
          this.dateEntretien = response.data.dateEntretien
          this.campusEntretien = response.data.campusEntretien
          this.ifContratR2 = response.data.ifContratR2
          this.referentHandicap = response.data.referentHandicap
          this.ifHandicap = response.data.ifHandicap
          this.ifCampus = response.data.campusAddress
        },
        (error) => {
          this.content =
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
              error.message ||
              error.toString();
        }
    );
  },
  methods: {
    urlFacebook: function () {
      let routeData = this.$router.resolve({name: 'public-facebook'});
      window.open(routeData.href, '_blank');
    },
    urlLinkedin: function () {
      let routeData = this.$router.resolve({name: 'public-linkedin'});
      window.open(routeData.href, '_blank');
    },
    urlInstagram: function () {
      let routeData = this.$router.resolve({name: 'public-instagram'});
      window.open(routeData.href, '_blank');
    },
    urlContact: function () {
      this.$router.push({name: 'contact'});
    },
    urlHandicap: function () {
      this.$router.push({name: 'referent-handicap'});
    },
    help: function () {
      let routeData = this.$router.resolve({name: 'public-help-contact'});
      window.open(routeData.href, '_blank');
    }
  },
};
</script>
